/**
 * Generic event throttler using requestAnimationFrame
 * adapted from pp-v5-shared/src/js/utils.js
 * @param {string} type
 * @param {string} name
 * @param {(Window & typeof globalThis) | undefined} [obj]
 */
function rafEvent(type, name, obj) {
    obj = obj || window;
    var running = false;
    var func = function () {
        if (running) {
            return;
        }
        running = true;
        requestAnimationFrame(function () {
            obj?.dispatchEvent(new CustomEvent(name));
            running = false;
        });
    };
    obj.addEventListener(type, func);
}

export default function init() {
    rafEvent("resize", "rafResize");
    rafEvent("scroll", "rafScroll");
}
